module.exports = __webpack_public_path__ + "img/zyadashop_logo.266659a0.png";